import React, { useState } from 'react'
import { Tab, WContainer } from '@next-nx/shared-ui/atoms'
import { StoreLocatorForm } from '@next-nx/shared-ui/molecules'
import styles from './StoreLocatorTabs.module.sass'
import { CENTRO_CONVENZIONATO_TIPI } from '@next-nx/utils/settings'

interface Props {
  tabs: any[]
  className?: string
}

const StoreLocatorTabs = (props: Props) => {
  const { tabs = [], className = '' } = props

  const [inputPlace, setInputPlace] = useState<{
    address: string
    coords: any
  }>()

  const [activeTab, setActiveTab] = useState(
    tabs.find((x) => CENTRO_CONVENZIONATO_TIPI.includes(x?.initialOption))?.key ||
      tabs?.[0]?.key ||
      null
  )

  return tabs.length > 0 ? (
    <div className={`${styles.root} ${className}`}>
      {tabs.length > 1 && (
        <WContainer>
          <div className={styles.tabTriggers}>
            {tabs.map((tab) => (
              <Tab.Trigger
                key={`tab-group-trigger__${tab.key}`}
                label={tab.label}
                active={tab.key === activeTab}
                onClick={() => setActiveTab(tab.key)}
                className={styles.tabTrigger}
              />
            ))}
          </div>
        </WContainer>
      )}
      <div className={styles.contents}>
        {tabs.length > 1 ? (
          tabs.map((tab) => (
            <Tab active={tab.key === activeTab} key={tab.key}>
              <div className={styles.tabContent}>
                <StoreLocatorForm
                  type={tab.key}
                  ctaLabel={tab.ctaLabel}
                  url={tab.url}
                  resultCtaLabel={tab.resultCtaLabel}
                  options={tab.options}
                  infoBox={tab.infoBox}
                  initialItems={tab.initialItems}
                  sharedInputPlace={inputPlace}
                  setSharedInputPlace={setInputPlace}
                  optionItems={tab.optionItems}
                  loadingOptionItems={tab.loadingOptionItems}
                  initialOption={tab.initialOption}
                />
              </div>
            </Tab>
          ))
        ) : (
          <StoreLocatorForm
            type={tabs[0].key}
            ctaLabel={tabs[0].ctaLabel}
            url={tabs[0].url}
            resultCtaLabel={tabs[0].resultCtaLabel}
            options={tabs[0].options}
            infoBox={tabs[0].infoBox}
            initialItems={tabs[0].initialItems}
          />
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}

export default StoreLocatorTabs
